/**
 * Hur utdelaren vill få sitt material. Ersätter "hemma från"-datumet: i stället för att admin
 * ska pussla ihop utkörning efter datum säger utdelaren själv hur hen vill ha det.
 *
 * API:t serialiserar enum som PascalCase-strängar (JsonStringEnumConverter), så det är de
 * värdena som skickas fram och tillbaka.
 */
export type MaterialOption = "OfficePickup" | "StageFriday" | "HomeDelivery";

export const MATERIAL_OPTIONS: MaterialOption[] = ["OfficePickup", "StageFriday", "HomeDelivery"];

export const MATERIAL_OPTION_LABELS: Record<MaterialOption, string> = {
    OfficePickup: "Hämta på kontoret",
    StageFriday: "Hämta på fredag i samband med scenprogrammet",
    HomeDelivery: "Få utkört"
};

/** Kort variant för tabellkolumner, där hela meningen inte får plats. */
export const MATERIAL_OPTION_SHORT_LABELS: Record<MaterialOption, string> = {
    OfficePickup: "Kontoret",
    StageFriday: "Fredag, scen",
    HomeDelivery: "Utkört"
};

export const normalizeMaterialOption = (
    value: string | null | undefined
): MaterialOption | null => {
    switch (value) {
        case "OfficePickup":
        case "officePickup":
            return "OfficePickup";
        case "StageFriday":
        case "stageFriday":
            return "StageFriday";
        case "HomeDelivery":
        case "homeDelivery":
            return "HomeDelivery";
        default:
            return null;
    }
};

export const materialOptionLabel = (value: string | null | undefined): string | null => {
    const option = normalizeMaterialOption(value);
    return option ? MATERIAL_OPTION_LABELS[option] : null;
};

export const materialOptionShortLabel = (value: string | null | undefined): string | null => {
    const option = normalizeMaterialOption(value);
    return option ? MATERIAL_OPTION_SHORT_LABELS[option] : null;
};
